/**
 * 获取用户信息 API
 */
export const TENVIDEO_GET_USERINFO_API = '//iwan.qq.com/api/v1/getNickAndAvatar';
export const WEISHI_GET_USERINFO_API = '//h5.weishi.qq.com/webapp/json/weishi/GetUserInfo?g_tk=';
export const SPORTS_GET_USERINFO_API = '//matchweb.sports.qq.com/user/qqInfo';
export const AC_GET_USERINFO_API = '//m.ac.qq.com/event/crayfish/action.php?action=getUserInfo';

export const getYybGetUserInfoApi = () => (/test=1/.test(location.search)
  ? 'https://iwan-test.yyb.qq.com/trpc.game_community.yyb_account.YybAccount/GetAndUpdateUserInfo'
  : '//iwan.yyb.qq.com/trpc.game_community.yyb_account.YybAccount/GetAndUpdateUserInfo');

/**
 * 腾讯视频 App 端的登录来源渠道号
 *
 * @link https://doc.weixin.qq.com/doc/w3_AEkAgwb6AEoGU7L2BfETNmc1FmbWQ?scode=AJEAIQdfAAoln11ONGAPQAQQbdAFw
 */
export const TENVIDEO_APP_LOGIN_SOURCE = 79;
